import { Box } from '@factorialco/deprecated-design-system'
import {
  AvailablePayrollConceptFieldFragment,
  PayrollRunEmployeesCompensationFormFragment,
} from 'generated/resources/graphql'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

import { FailedLabel } from './FailedLabel'
import { SimpleLabel } from './SimpleLabel'

const formatDate = (date: string) => {
  return i18nDateToString(stringToDate(date, 'backend_datetime'), 'ui_month_day_time')
}

interface CollapsableCardSyncCompensationsLabelProps {
  payrollRunEmployeeCompensations: Array<PayrollRunEmployeesCompensationFormFragment>
  compensationConcept: AvailablePayrollConceptFieldFragment
}

export const CollapsableCardSyncCompensationsLabel = ({
  payrollRunEmployeeCompensations,
  compensationConcept,
}: CollapsableCardSyncCompensationsLabelProps) => {
  const { syncEnabled } = useIntegrationsSyncContext()

  const syncableState =
    payrollRunEmployeeCompensations.find(
      (node) => node?.payrollConcept?.id === compensationConcept.id
    )?.syncableState?.[0] || null

  if (!syncEnabled) return null

  const status = syncableState?.status

  const statusContentMap: Record<string, JSX.Element> = {
    failed: (
      <FailedLabel
        errorMessages={Object.values(JSON.parse(syncableState?.errorMessages ?? '{}')).join(', ')}
      />
    ),
    invalid: (
      <FailedLabel
        errorMessages={Object.values(JSON.parse(syncableState?.errorMessages ?? '{}')).join(', ')}
      />
    ),
    syncing: <SimpleLabel label={i18n.t('integrations.syncable_status.syncing')} />,
    outdated: <SimpleLabel label={i18n.t('integrations.syncable_status.outdated')} />,
    synced: (
      <SimpleLabel
        label={`${i18n.t('integrations.syncable_status.synced')} ${formatDate(
          syncableState?.statusUpdatedAt
        )}`}
      />
    ),
  }

  return (
    <Box paddingTop="s8" paddingX="s12" width="full" textAlign="right">
      {(status && statusContentMap[status]) || (
        <SimpleLabel label={i18n.t('integrations.syncable_status.pending')} />
      )}
    </Box>
  )
}
